import React from 'react'

import { ScrollbarContainer } from '@/components/Scrollbar/styles'
import { orientation as ScrollbarBarOrientation } from '@/constants/focus'
import { isPointerMode } from '@/utils/utils'

type Props = {
  length: number
  activeIndex: number
  onProgressClick?: (index: number) => void
  orientation?: ScrollbarBarOrientation
}

export const Scrollbar = ({
  length,
  activeIndex = 0,
  onProgressClick,
  orientation = ScrollbarBarOrientation.HORIZONTAL,
}: Props) => {
  return (
    <ScrollbarContainer
      $orientation={orientation}
      $activeIndex={activeIndex}
      $length={length}
    >
      <ul>
        {[...Array(length)].map((_, index) => {
          const isLeftCorner = index < activeIndex - 1 && index < length - 4
          const isRightCorner = index > activeIndex + 1 && index > 3
          const isSmall = length > 5 && (isLeftCorner || isRightCorner)
          return (
            <li
              key={index}
              className={`${index === activeIndex ? 'is-active' : ''} ${
                isSmall ? 'is-small' : ''
              }`}
              onClick={() => isPointerMode && onProgressClick?.(index)}
            ></li>
          )
        })}
      </ul>
    </ScrollbarContainer>
  )
}
